
export const RINGBA_TAG_VALUES = [
  { text: "true", value: true },
  { text: "false", value: false },
  { text: "53", value: 53 },
  { text: "65", value: 65 },
  { text: "86", value: 86 },
];

export const AUDIO_FILE = {
  fileID: "",
  fileURL: "",
  fileName: "",
};

export const ACTION = {
  messageType: "action",
  delay: 0,
  cssClass: "",
  backgroundColor: "",
  children: [],
  columns: null,
};

export const ACTION_ITEM = {
  messageType: "actionItem",
  text: "",
  link: "",
  backgroundColor: "",
  value: "",
  hasRingbaScript: false,
  ringbaScript: "",
  ringbaTags: [],
  children: [],
  audio: { ...AUDIO_FILE },
};

export const INPUT_QUESTION = {
  messageType: "inputQuestion",
  delay: 0,
  content: "",
  children: [],
  inputQuestionType: "",
  inputQuestionDisplayType: "",
  buttonText: "Confirm",
  buttonColor: "",
};

export const DECISION = {
  messageType: "decision",
  children: [],
  ringbaTags: [],
  greaterThan: null,
  greaterThanOrEqual: null,
  lessThan: null,
  lessThanOrEqual: null,
};

export const INPUT_QUESTION_DISPLAY_TYPES = [
  { value: "years", text: "Years (ex. 1959)" },
  { value: "age", text: "Age (ex. 60)" },
];

export const ZIP_INPUT_QUESTION = {
  messageType: "zipInputQuestion",
  delay: 0,
  content: "",
  children: [],
  zipInputDisplayType: "",
  buttonText: "Confirm",
  buttonColor: "",
  placeholderText: "e.g., 12345",
  overrideZipOnly: true,
  overrideZipAndLocation: false,
};

export const ZIP_INPUT_DISPLAY_TYPES = [
  { value: "empty", text: "Empty input" },
  { value: "prefilled", text: "Pre-filled input" },
];

export const ZIP_OVERRIDE_MODE = {
  ZIP_ONLY: "zipOnly",
  ZIP_AND_LOCATION: "zipAndLocation",
};

// MP4: per-message defaults. totalTypingTimeMs: 0 = show immediately; empty = use global typing speed; >0 = finish typing by that time (ms)
export const MESSAGE_MP4_DEFAULTS = {
  mp4Url: "",
  mp4FileId: "",
  videoOffsetX: null,
  videoOffsetY: null,
  totalTypingTimeMs: null,
};

export const MESSAGE_MP4 = {
  messageType: "message",
  content: "",
  backgroundColor: "",
  delay: 0,
  cssClass: "",
  hasRingbaScript: false,
  ringbaScript: "",
  children: [],
  audio: { ...AUDIO_FILE },
  isLastMessage: false,
  mp4Url: "",
  mp4FileId: "",
  videoOffsetX: null,
  videoOffsetY: null,
  totalTypingTimeMs: null,
};

// MP4: video preload strategy on the rendered page side. Empty value keeps existing master behavior.
export const VIDEO_PRELOAD_MODE_OPTIONS = [
  { value: "", textKey: "shortcodes.live_chat_mp4.video_preload_mode_default" },
  { value: "none", textKey: "shortcodes.live_chat_mp4.video_preload_mode_none" },
  { value: "preload-branch", textKey: "shortcodes.live_chat_mp4.video_preload_mode_preload_branch" },
  { value: "prefetch-branch", textKey: "shortcodes.live_chat_mp4.video_preload_mode_prefetch_branch" },
];

// MP4: full root-level default shape (typingSpeed = ms per character; unchanged by per-message total typing time)
export const LIVE_CHAT_MP4_ROOT_DEFAULTS = {
  waitingPillLabel: "waiting after you",
  typingSpeed: 50,
  waitingLoopMp4Url: "",
  waitingLoopMp4FileId: "",
  waitingLoopVideoOffsetX: null,
  waitingLoopVideoOffsetY: null,
  maxAvatarSize: 240,
  loaderMessage: "Mary is typing…",
  botAvatar: {
    imageID: "",
    imageURL: "",
  },
  actionItemBackgroundColor: "#007bee",
  messageBackgroundColor: "#ffffff",
  videoPreloadMode: "",
  messages: [],
};

// MP4: ACTION and ACTION_ITEM optional fields
export const LIVE_CHAT_MP4_ACTION_DEFAULTS = {
  ctaLayout: "vertical",
  textBelowCta: "",
};

export const LIVE_CHAT_MP4_ACTION_ITEM_DEFAULTS = {
  textColor: "",
};
